<template>
  <Container class="serve-you">
    <h2 class="heading">I am honoured to serve you!</h2>
    <div class="content">
      <div class="left">
        <div
          class="box"
          v-for="lbox in boxes.left"
          :key="lbox.title"
          role="button"
          @click="navigate(lbox.href)"
        >
          <img v-lazy="lbox.image" :alt="lbox.title" />
          <h3 class="title" v-text="lbox.title"></h3>
        </div>
      </div>
      <div class="right">
        <div
          class="box"
          v-for="rbox in boxes.right"
          :key="rbox.title"
          role="button"
          @click="navigate(rbox.href)"
        >
          <img v-lazy="rbox.image" :alt="rbox.title" />
          <h3 class="title" v-text="rbox.title"></h3>
        </div>
      </div>
    </div>
    <img
      v-lazy="asset('images/helpers/serve-you.png')"
      :alt="app_name()"
      class="hero-img"
    />
  </Container>
</template>
<script>
export default {
  data() {
    return {
      boxes: {
        left: [
          {
            title: "Seeker",
            image: this.asset("images/helpers/seeker.jpg"),
            href: "#seeker",
          },
          {
            title: "Facilitator",
            image: this.asset("images/helpers/facilitator.bmp"),
            href: "#facilitator",
          },
          {
            title: "Life Coach",
            image: this.asset("images/helpers/lifecoach.jpg"),
            href: "#lifecoach",
          },
        ],
        right: [
          {
            title: "Story Teller",
            image: this.asset("images/helpers/storyteller.jpg"),
            href: "#storyteller",
          },
          {
            title: "Change Maker",
            image: this.asset("images/helpers/changemaker.jpg"),
            href: "#changemaker",
          },
          {
            title: "Healer",
            image: this.asset("images/helpers/healer.jpg"),
            href: "#healer",
          },
        ],
      },
    };
  },
  methods: {
    navigate(href) {
      // scroll to the section
      const $section = $(href);

      if ($section.length) {
        $("html").animate(
          {
            scrollTop: $section.offset().top - 100,
          },
          100
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.serve-you {
  padding: 2rem 0;
  position: relative;
  padding-top: 3.1rem;
  .heading {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 1.1rem;
    text-align: center;
    color: var(--dark);
  }

  .content {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 2rem;
    position: relative;
    z-index: 5;
    @media (max-width: 576px) {
      gap: 1rem;
    }

    .left,
    .right {
      flex: 1;
      height: 100%;
    }

    .box {
      --size: 300px;
      width: var(--size);
      height: calc(var(--size) / 1.5);
      position: relative;
      margin: 0 auto;
      margin-bottom: 1rem;
      border-radius: var(--border-radius);
      overflow: hidden;
      box-shadow: var(--box-shadow);
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .title {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        color: #fff;
        text-align: center;
        padding: 0.5rem 0;
        font-size: 1.2rem;
        font-weight: bold;
        text-transform: uppercase;
        margin: 0;
        font-family: var(--font-family);
        z-index: 5;
      }

      &:before {
        content: "";
        position: absolute;
        z-index: 4;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.5) 0%,
          rgba(0, 0, 0, 0) 100%
        );
      }

      &:hover {
        img {
          transform: scale(1.03);
        }
      }

      &:last-child {
        margin-bottom: 0;
      }

      @media (max-width: 768px) {
        width: 100%;
      }

      @media (max-width: 576px) {
        --size: 200px;

        .title {
          font-size: 0.9rem;
        }
      }
    }

    @media (min-width: 992px) {
      .left .box {
        margin-right: auto;
        margin-left: 0;
      }
      .right .box {
        margin-left: auto;
        margin-right: 0;
      }
    }
  }

  .hero-img {
    position: absolute;
    left: 50%;
    bottom: -30px;
    height: 100%;
    transform: translateX(-50%);
    @media (max-width: 992px) {
      display: none;
    }
  }

  @media (max-width: 768px) {
    padding-top: 2rem;
    .heading {
      font-size: 2rem;
    }
  }

  @media (max-width: 576px) {
    padding-top: 1rem;
    .heading {
      font-size: 1.8rem;
    }
  }
}
</style>